import { Box, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const StatBox = styled(Box)(({ theme }) => ({
  flex: '1 1 auto',
  textAlign: 'left',
  padding: theme.spacing(1.25, 1.6),
  background: '#ffffff',
  borderRadius: 8,
  border: '1px solid #e2e8f0',
  boxShadow: '0 1px 2px rgba(15, 23, 42, 0.05), 0 6px 14px rgba(15, 23, 42, 0.04)',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  justifyContent: 'center',
  minWidth: 0,
}));

export interface VisitStats {
  count: number | string;
  dwell: string;
  avgTemp: string;
}

interface VisitJourneyStatsProps {
  stats: VisitStats;
}

export default function VisitJourneyStats({ stats }: VisitJourneyStatsProps) {
  const items: { label: string; value: string | number }[] = [
    { label: 'Sightings', value: stats.count },
    { label: 'Visit duration', value: stats.dwell },
    { label: 'Avg temp', value: stats.avgTemp },
  ];

  return (
    <Stack
      direction='row'
      spacing={1}
      alignItems='stretch'
      sx={{
        px: 1.5,
        py: 1,
        borderBottom: '1px solid',
        borderColor: '#e7edf5',
      }}
    >
      {items.map((item) => (
        <StatBox key={item.label}>
          <Typography
            variant='h5'
            fontWeight={700}
            sx={{
              color: '#111827',
              lineHeight: 1.15,
              fontSize: 18,
              whiteSpace: 'nowrap',
            }}
          >
            {item.value}
          </Typography>
          <Typography
            variant='body2'
            sx={{
              color: '#64748b',
              fontWeight: 500,
              whiteSpace: 'nowrap',
            }}
          >
            {item.label}
          </Typography>
        </StatBox>
      ))}
    </Stack>
  );
}
